import styled from 'styled-components';

const StyledTightIntroduction = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const StyledCenteredImage = styled.img`
  border-radius: ${(props) => props.theme.radius.md};
  max-width: 100%;
`;

const StyledBlockImage = styled.img`
  border-radius: ${(props) => props.theme.radius.md};
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
`;

const StyledLocalQuote = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const StyledCarouselImage = styled.img`
  border-radius: ${(props) => props.theme.radius.md};
  max-width: 60vw;
  min-height: 500px;
  @media (max-width: 768px) {
    min-height: 300px;
  }
  object-fit: cover;
`;
const StyledInsightsCollection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

export {
  StyledTightIntroduction,
  StyledCenteredImage,
  StyledBlockImage,
  StyledLocalQuote,
  StyledCarouselImage,
  StyledInsightsCollection,
};
